module.exports = __webpack_public_path__ + "img/takeout-img1.7ec193d8.png";